setTimeout(function () {
    var OGONE_CC_FORM = $( "form[name=OGONE_CC_FORM]" );
    var paymentFormCont = $( "#paymentServiceContainer .paymentForm" );
    var imgCardDOM = $( "input[name='card'] + img" );
    var newPaymentImgDOM = $( "img.paymentImg" );
    var inputCardNameDOM = $( "#Ecom_Payment_Card_Name" );
    var inputCardNumberDOM = $( "#Ecom_Payment_Card_Number" );
    var trs = $('.ncoltable2 tr');
    var customerService = $('.customerService');
    var paymentForm = paymentFormCont.find('form');
    var ncoltable3 = paymentFormCont.find('.ncoltable3');
    var sendCardButton = $('#btn_sendCardData');
    var VISA_brand = $('input[name=VISA_brand]');
    var Eurocard_brand = $('input[name=Eurocard_brand]');

    if (!paymentForm.length) {
        return
    }

    if (paymentForm.length && VISA_brand.length && Eurocard_brand.length) {
        window.location.href = "https://www.futurum.cc/?action=cart/chooseAccount&check=1";
        return
    }

    if(sendCardButton.parent()){
        sendCardButton.parent().prev().prev().css("display", "none");
    }

    if(OGONE_CC_FORM.length){
        OGONE_CC_FORM.siblings('style').remove();
    }

    ncoltable3.css("opacity", "1");
    paymentForm.css("opacity", "1");
    customerService.css("opacity", "1");

    var trVervaldatum = $('<div class="subHeading">Card expiry date</div>');
    var trHieronder = $('<div class="subHeading">Please fill in your card\'s CVC code below</div>');

    var dateMonthDOM = $( "#Ecom_Payment_Card_ExpDate_Month" );
    var dateYearDOM = $( "#Ecom_Payment_Card_ExpDate_Year" );
    var dateVerificationDOM = $( "#Ecom_Payment_Card_Verification" );

    var smallTag = dateMonthDOM.parent();

    if(imgCardDOM.length){
        $( ".paymentForm .title h2" ).text('Pay with ' + imgCardDOM.attr('title') + ' card');
    }

    smallTag.empty();

    smallTag.append(dateMonthDOM);
    smallTag.append(dateYearDOM);

    dateMonthDOM.wrap('<div class="customSelect"></div>');
    dateYearDOM.wrap('<div class="customSelect"></div>');

    dateVerificationDOM.addClass('customSelect');

    if (trs.length) {
        $(trs[2]).after(trVervaldatum[0]);
        $(trs[3]).after(trHieronder[0]);

        if(imgCardDOM[0]){
            if(newPaymentImgDOM[0]){
                newPaymentImgDOM[0].src = imgCardDOM[0].src;
                trs.first().css('display', 'none');
            }
        }
    }

    inputCardNameDOM[0].required = true;
    inputCardNumberDOM[0].required = true;

    inputCardNameDOM.parent().append($('<label ph="Cardholder name" fl="Cardholder name"></label>'));
    inputCardNumberDOM.parent().append($('<label ph="Card number" fl="Card number"></label>'));



}, 1000);